import styled from 'styled-components';

export const AtomLoginText = styled.h1`
    margin-bottom: 10px;
    font-family: Bogart;
    font-size: 24px;
    color: ${({ theme }): string => theme.colors.grey900};
    line-height: 20px;
`;

export const AtomMessage = styled.p`
    margin-top: 20px;
    padding-top: 20px;
    font-family: Roboto;
    font-size: 16px;
    color: ${({ theme }): string => theme.colors.grey900};
    line-height: 24px;
    width: 100%;
    max-width: 432px;
`;
